import {
  restResourceResolver,
  batchRestResourceResolver,
} from './restResourceResolver/restResourceResolver';
import {
  announcementsResolver,
  dismissAnnouncement,
} from './resolvers/announcements';
import {
  uploadCardCover,
  updateCardCover,
  createCardTemplate,
  copyCard,
  deleteCard,
} from './resolvers/card';
import {
  addChecklist,
  deleteChecklist,
  updateChecklistName,
  updateChecklistPos,
} from './resolvers/checklist';
import {
  addCheckItem,
  deleteCheckItem,
  updateCheckItemName,
  updateCheckItemPos,
  updateCheckItemState,
} from './resolvers/checkItem';
import { emailProviderResolver } from './resolvers/emailProvider';
import {
  addOneTimeMessagesDismissed,
  updateUserLocale,
  deleteOneTimeMessagesDismissed,
  prepMemberForAtlassianAccountOnboarding,
  prepMemberForEmailHygiene,
  memberAgreementsResolver,
  acceptDeveloperTerms,
  updateMemberAvatarSource,
  uploadMemberAvatar,
  addCampaign,
  updateCampaign,
  resendVerificationEmail,
  changeMemberEmail,
} from './resolvers/member';
import {
  organizationOwnedPluginsResolver,
  organizationStatsResolver,
  organizationCardStatsResolver,
  organizationLabelNamesResolver,
  organizationNewBillableGuestsResolver,
  createOrganization,
  copyBoardToOrg,
  deleteOrganizationLogo,
  addMembersToOrg,
  updateOrganization,
  uploadOrganizationImage,
} from './resolvers/organization';
import {
  paidAccountCustomTypeResolver,
  salesTaxResolver,
  salesTaxForSubscriberResolver,
  createBusinessClassPaidAccount,
  createGoldPaidAccount,
  activateGoldCredit,
  updateCreditCard,
  updatePaidProduct,
  updateInvoiceDetails,
} from './resolvers/paidAccount';
import {
  publicPluginsResolver,
  pluginCategoriesResolver,
} from './resolvers/publicPlugin';
import { unsplashPhotosResolver } from './resolvers/unsplash';

import {
  enablePlugin,
  updateBoardOrg,
  boardExportResolver,
  startBoardExport,
} from './resolvers/board';
import {
  createPlugin,
  deletePlugin,
  updatePlugin,
  createPluginListing,
  updatePluginListing,
} from './resolvers/plugin';
import {
  templateCategoriesResolver,
  templateGalleryResolver,
} from './resolvers/template';
import {
  enterpriseClaimableOrganizationsResolver,
  transferrableDataForOrganizationResolver,
  claimOrganization,
} from './resolvers/enterprise';

export const resolvers = {
  Query: {
    announcements: announcementsResolver,
    board: restResourceResolver,
    boards: batchRestResourceResolver,
    card: restResourceResolver,
    cards: batchRestResourceResolver,
    checklist: restResourceResolver,
    checklists: batchRestResourceResolver,
    list: restResourceResolver,
    lists: batchRestResourceResolver,
    emailProvider: emailProviderResolver,
    member: restResourceResolver,
    members: batchRestResourceResolver,
    organization: restResourceResolver,
    organizations: batchRestResourceResolver,
    label: restResourceResolver,
    labels: batchRestResourceResolver,
    enterprise: restResourceResolver,
    enterprises: batchRestResourceResolver,
    publicPlugins: publicPluginsResolver,
    salesTax: salesTaxResolver,
    salesTaxForSubscriber: salesTaxForSubscriberResolver,
    search: restResourceResolver,
    plugin: restResourceResolver,
    pluginCategories: pluginCategoriesResolver,
    unsplashPhotos: unsplashPhotosResolver,
    templateCategories: templateCategoriesResolver,
    templateGallery: templateGalleryResolver,
  },
  Mutation: {
    addChecklist,
    addOneTimeMessagesDismissed,
    createOrganization,
    copyBoardToOrg,
    updateBoardOrg,
    dismissAnnouncement,
    deleteChecklist,
    updateChecklistName,
    updateChecklistPos,
    addCheckItem,
    deleteCheckItem,
    addCampaign,
    updateCampaign,
    updateCheckItemName,
    updateCheckItemPos,
    updateCheckItemState,
    updateUserLocale,
    updateOrganization,
    prepMemberForAtlassianAccountOnboarding,
    prepMemberForEmailHygiene,
    deleteOneTimeMessagesDismissed,
    createPlugin,
    deletePlugin,
    enablePlugin,
    updatePlugin,
    createPluginListing,
    updatePluginListing,
    acceptDeveloperTerms,
    updateMemberAvatarSource,
    updateCardCover,
    uploadCardCover,
    uploadMemberAvatar,
    changeMemberEmail,
    resendVerificationEmail,
    addMembersToOrg,
    createCardTemplate,
    copyCard,
    deleteCard,
    startBoardExport,
    claimOrganization,
    createBusinessClassPaidAccount,
    createGoldPaidAccount,
    activateGoldCredit,
    updateCreditCard,
    updatePaidProduct,
    updateInvoiceDetails,
    uploadOrganizationImage,
    deleteOrganizationLogo,
  },

  // Custom type resolvers
  Board: {
    export: boardExportResolver,
    exports: boardExportResolver,
  },

  Enterprise: {
    claimableOrganizations: enterpriseClaimableOrganizationsResolver,
    transferrableData: transferrableDataForOrganizationResolver,
  },

  Member: {
    agreements: memberAgreementsResolver,
    paidAccount: paidAccountCustomTypeResolver,
  },

  Organization: {
    ownedPlugins: organizationOwnedPluginsResolver,
    stats: organizationStatsResolver,
    newBillableGuests: organizationNewBillableGuestsResolver,
    paidAccount: paidAccountCustomTypeResolver,
  },

  Organization_Stats: {
    cards: organizationCardStatsResolver,
    labelNames: organizationLabelNamesResolver,
  },
};
